import React, { useEffect, useState } from "react";
import VendorForm from "../VendorForm/VendorForm";
import { useLocation, useNavigate } from "react-router-dom";
import functions from "../../../utils/Api";
import HomeIcon from "@mui/icons-material/Home";
import { Box } from "@mui/material";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import { CircularProgress } from "@mui/material";
import Toaster from "../../../components/Toaster/Toaster";
import { useDispatch } from "react-redux";
import { dispatchRefreshApiCallVendor } from "../../../Redux/dispatcher";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import { setToasterStatusMsg, setUserType } from "../../../Redux/reportSlice";

const EditVendor = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const dispatcher = useDispatch();
  let id = location.pathname.split("/")[3];
  const [vendorDetailStatus, setVendorDetailStatus] = useState(false);
  const [disableCreateBtn, setDisableCreateBtn] = useState(false);
  const [vendorDetails, setVendorDetails] = useState({
    vendorName: "",
    vendorLocationId: "",
    vendorEmail: "",
    vendorPhone: "",
    isActive: true,
  });

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  useEffect(() => {
    if (id) {
      try {
        functions
          .get(`/vendor/${Number(id)}`)
          .then((res) => {
            setVendorDetailStatus(true);
            setVendorDetails({
              vendorName: res?.data ? res.data?.vendorName : "",
              vendorLocationId: res?.data ? res.data?.vendorLocationId : "",
              vendorEmail: res?.data ? res.data?.vendorEmail : "",
              vendorPhone: res?.data ? res?.data?.vendorPhone : "",
              isActive: res.data ? res?.data?.isActive : true,
            });
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    }
  }, [id]);

  useEffect(() => {
    dispatcher(setUserType(2));
  }, [dispatcher]);

  const handleVendorSubmit = async () => {
    setDisableCreateBtn(true);
    try {
      const res = await functions.put(`/vendor/${id}`, vendorDetails);
      if (res) {
        setDisableCreateBtn(false);
        dispatcher(dispatchRefreshApiCallVendor(true));
        dispatcher(
          setToasterStatusMsg({
            msg: "Vendor Updated successfully",
            severity: "success",
          })
        );
        navigate(`/cms/users-list`);
      }
    } catch (err) {
      dispatcher(
        setToasterStatusMsg({
          msg: err.message || "Something went wrong",
          severity: "error",
        })
      );
      setDisableCreateBtn(false);
      console.error(err);
    }
  };

  return (
    <div>
      <Box className="Admin-breadCrumb">
        <CustomBreadcrumbs items={breadCrumbData} currentLabel="Users" />
      </Box>
      {vendorDetailStatus ? (
        <VendorForm
          title="Update"
          vendorDetails={vendorDetails}
          setVendorDetails={setVendorDetails}
          handleVendorSubmit={handleVendorSubmit}
          disableCreateBtn={disableCreateBtn}
        />
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
};

export default EditVendor;
